import { OrdersResponse } from 'entities/common/my-ticket/model/types'
import {
  AppSettings,
  IDocument,
  LoginUser,
  ResponseUser,
  SentSettingOfUser,
} from 'entities/user/module'

import { MyTicketItem } from 'shared/api/MyTicketsModel.ts'
import { Pagination, Response } from 'shared/models/general.ts'

import { clientApi } from './clientApi'

interface ResponseMyTicket extends Pagination, Response<MyTicketItem[]> {}

interface PaginationMyTickets extends Pagination {
  active?: boolean
}

interface OrdersCount {
  orders: {
    category: string
    count: number
  }[]
  total_count: number
}

interface AuthUser {
  token: string
  device_id?: string
}

export const UserApi = {
  loginUser({ token, device_id }: AuthUser) {
    return clientApi.post<LoginUser>(
      '/auth/login',
      { token, device_id },
      { headers: { token } },
    )
  },

  loginUserByDeviceId() {
    return clientApi.get<ResponseUser>('/auth/user-by-device')
  },

  loginInnerUser(inner_token: string) {
    return clientApi.post<LoginUser>(
      '/auth/login',
      { inner_token },
      { headers: { inner_token } },
    )
  },

  getUser() {
    return clientApi.get<ResponseUser>('/profile')
  },

  updateUserDocuments(data: IDocument) {
    return clientApi.post<ResponseUser>('/profile/documents', data)
  },

  getMyTickets(data?: PaginationMyTickets) {
    return clientApi.get<ResponseMyTicket>('/flights/tickets', {
      params: data,
    })
  },

  updateEmail(email: string) {
    return clientApi.post('/profile', { email })
  },

  checkUser(redirect_url?: string) {
    return clientApi.post('/auth/require', { redirect_url })
  },

  getAppSettings() {
    return clientApi.get<Response<AppSettings>>('/profile/settings')
  },
  patchAppSettings(data: Partial<SentSettingOfUser>) {
    return clientApi.patch<Response<AppSettings>>('/profile/settings', data)
  },
  getMyOrders(isActive: string) {
    return clientApi.get<Response<OrdersResponse>>('/profile/orders', {
      params: { is_active: isActive },
    })
  },

  getMyOrdersCount(signal?: AbortSignal) {
    return clientApi.get<Response<OrdersCount>>('/profile/orders/count', {
      signal,
    })
  },

  sentAppealTouraika({ session_id }: { session_id: string }) {
    return clientApi.post<{ session_id: string }>('/profile/touraika/appeal', {
      session_id,
    })
  },
}
